module.exports = __webpack_public_path__ + "static/media/user-icon.7ebf1219.svg";